<div class="primary-bg p-v-6 text-align-justify" fxLayoutAlign="center start" style="width: 100vw">
  <button (click)="location.back()" class="tint-white back" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="p-6" style="width: 1000px">
    <router-outlet />
  </div>
</div>
<recrewt-footer />
